import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getFulfillmentGroupTracking } from "@redotech/redo-fulfillment-group-common/fulfillment-group-tracking";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { TrackingNumbersDisplay } from "../../common/tracking/tracking-numbers-display";

const catalogEntry = fgColumnEntries.trackingNumber;

export const TrackingNumberColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  width: catalogEntry.defaultWidth,
  renderNormalCell: ({ row }) => {
    const tracking = getFulfillmentGroupTracking(row);
    if (!tracking.length) {
      return null;
    }
    return (
      <Flex minW="none" pl="lg">
        <TrackingNumbersDisplay
          tracking={tracking.map(({ link, trackingNumber }) => ({
            link,
            trackingNumber,
          }))}
        />
      </Flex>
    );
  },
  alignment: ColumnAlignment.LEFT,
};
